import React, { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Circle, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";

// Fix default marker icon paths (Leaflet's bundler quirk)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) map.setView([lat, lng]);
  }, [lat, lng, map]);
  return null;
}

/**
 * Interactive map: click anywhere to set lat/lng, shows radius circle.
 * Used on Stores page.
 */
export default function StoreMap({ latitude, longitude, radiusMeters, onPick, height = 360, interactive = true, mapKey }) {
  const center = useMemo(() => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);
    if (!isNaN(lat) && !isNaN(lng) && (lat || lng)) return [lat, lng];
    return [37.7749, -122.4194];
  }, [latitude, longitude]);

  const hasPin = !isNaN(parseFloat(latitude)) && !isNaN(parseFloat(longitude)) && (parseFloat(latitude) || parseFloat(longitude));

  return (
    <div className="border border-zinc-300 rounded-sm overflow-hidden" data-testid="store-map">
      <MapContainer
        key={mapKey}
        center={center}
        zoom={hasPin ? 14 : 11}
        style={{ height, width: "100%" }}
        scrollWheelZoom={interactive}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {interactive && onPick && <ClickHandler onPick={onPick} />}
        <Recenter lat={center[0]} lng={center[1]} />
        {hasPin && (
          <>
            <Marker position={center} />
            {radiusMeters > 0 && (
              <Circle
                center={center}
                radius={Math.min(radiusMeters, 50000)}
                pathOptions={{ color: "#002FA7", fillColor: "#002FA7", fillOpacity: 0.1, weight: 2 }}
              />
            )}
          </>
        )}
      </MapContainer>
    </div>
  );
}
